// src/components/reader/askAiFab.js
//
// When the floating "Ask AI" button shows (reader-ai-fab). One predicate shared by
// both readers and the DEV harness, so the hide list cannot drift between them and is
// unit-tested rather than eyeballed. Every input is a boolean the reader already holds.
//
//   canAsk         -- the header's own Ask AI button would render (its `onAskAi` guard).
//                     If AI is not offered for this pack/user, the FAB is not either.
//   initialLoading -- the reader has nothing to show yet.
//   aiOpen         -- the AI drawer is open: the FAB must never float over its own drawer.
//   notesOpen      -- the notes drawer is open.
//   inPractice     -- a practice session (quiz / flashcards / essay) is active. Each
//                     reader passes what its own LessonBottomBar guard uses for this.
//   sheetOpen      -- the sections sheet is open.
export function showAskAiFab({ canAsk, initialLoading, aiOpen, notesOpen, inPractice, sheetOpen }) {
    return !!canAsk && !initialLoading && !aiOpen && !notesOpen && !inPractice && !sheetOpen;
}
